import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UtilServico } from 'src/app/servicos/util.servico';
import { UtilDadosLogado } from 'src/app/servicos/util.logado';
import { Router } from '@angular/router';
import { UploadService } from 'src/app/upload/upload.service';
import { HttpEventType } from '@angular/common/http';
import swal from 'sweetalert2';
import { finalize } from 'rxjs/internal/operators/finalize';
import Swal from 'sweetalert2';
import { TransmissaoA1Service } from 'src/app/servicos/transmissao-a1.service';

@Component({
  selector: 'app-s1000-Form',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './s1000Form.component.html',
  styleUrls: ['./s1000Form.component.scss']
})


export class S1000FormComponent implements OnInit {
  Form: FormGroup;
  dados: any = {};

  validacao_mensagens = {
    tipo: [{ type: 'required', message: 'Tipo é requerido' }]
  };
  Carregando: boolean;

  tipo_assinatura: string = "";
  db_config!: any;
  usuario_id!: any;
  loandTransmissao: boolean = false;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<S1000FormComponent>,
    private utilServico: UtilServico,
    private utilDadosLogado: UtilDadosLogado,
    private router: Router,
    private uploadService: UploadService, 
    private snackBar: MatSnackBar, 
    @Inject(MAT_DIALOG_DATA) public dados2: any
  ) {
    this.Form = fb.group({
      tipo: [null, Validators.required],
      iniValid: [null, Validators.required],
      fimValid: [null, Validators.required]
    });
  }

  ngOnInit() {

    // this.transmissor.transmitindo$.subscribe( (data: any)=>{
    //     this.loandTransmissao = data;
    // })

    const { usuario_id, db_config, tipo_assinatura } = this.utilDadosLogado.DadosAcesso();

    this.tipo_assinatura = tipo_assinatura;
    this.db_config = db_config
    this.usuario_id = usuario_id;

    this.dados.tipo = this.dados2.tipo;

    this.dados.iniValid = '07/2021';
    this.dados.ambiente_esocial = this.db_config.ambiente_esocial;
    this.dados.fimValid =
      (new Date().getMonth() + 1).toString().length < 2
        ? '0' + (new Date().getMonth() + 1).toString() + '/' + new Date().getFullYear().toString()
        : (new Date().getMonth() + 1).toString() + '/' + new Date().getFullYear().toString();
  }

  Validaform() {
    if (this.dados.tipo === null) return false;
    if (this.dados.iniValid === null) return false;
    if (this.dados.fimValid === null) return false;
    return true;
  }

  Salvar(): void {

    this.loandTransmissao = true;
    this.dados.iniValid = this.dados.tipo == "E" ? '07/2021' : this.dados.iniValid;

    if (this.Validaform()) {
      this.utilServico.Post('TabelaRubrica/S1000',
        {
          tipo_xml: this.dados.tipo,
          usuario_id: this.usuario_id,
          db_config: this.db_config,
          iniValid: this.dados.iniValid,
          fimValid: this.dados.fimValid
        },
        true
      )
        .subscribe(
          (data: any) => {
            if (this.tipo_assinatura == 'A1') {
              this.transmissaoA1(data);
            } else {
              var event = document.createEvent('CustomEvent');
              event.initCustomEvent('EnviarDadosString', true, true, {
                metodo: 'ExEsocial',
                xml: data.xml,
                ambiente: data.Ambiente,
                retaguarda: data.Retaguarda,
                ws: this.utilDadosLogado.DadosAcesso().url,
                tipoenvio: 'N'
              });
              document.documentElement.dispatchEvent(event);
              this.dialogRef.close();
            }
            
          },
          (error: any) => {
            swal.fire({
              title: 'Atenção!',
              type: 'warning',
              html:
                'Favor informar periodo válido! <br/> <b>Formato: MM/AAAA</b>'
            });
            this.loandTransmissao = false;
          }
        );
    } else {
      swal.fire({ title: 'Erro Preencha formulario!' });
      this.loandTransmissao = false;
    }
  }

  
  transmissaoA1(data: any) {

    this.loandTransmissao = true;

    this.utilServico.Post('TabelaRubrica/LoteEnvioA1Individual',
      {
        metodo: 'ExEsocial',
        // xml: data.xml,
        ambiente: data.Ambiente,
        retaguarda_id: data.Retaguarda,
        usuario_id: this.usuario_id,
        db_config: this.db_config,
        origem_dado_id: this.db_config.origem_dado_id
      },
      true
    )
    .pipe(
      finalize(() => {
        // Esta função será chamada tanto no sucesso quanto no erro
        this.dialogRef.close();
      })
    )
    .subscribe(
      (data: any) => {
        swal.fire({
          title: 'Transmissão',
          html: data.message,
          type: 'success',
          timer: 3000,
          showConfirmButton: false
          
        })
        this.loandTransmissao = false;
      },
      (error: any) => {
        // Lógica em caso de erro
        this.showWarning(JSON.parse(error._body).message);
        this.loandTransmissao = false;
      }
    );
  }

  handleFileInput(files: FileList, row: any) {
    const DadosAcesso = this.utilDadosLogado.DadosAcesso();
    const fileToUpload = files.item(0);
    const formData = new FormData();
    formData.append('file', fileToUpload, fileToUpload.name);
    formData.append('SeguradoId', "0");
    formData.append('Tipo', '1000');
    this.uploadService.Upload('Retaguarda/Upload', formData).subscribe(
      (event: any) => {
        if (event.type === HttpEventType.UploadProgress) {
          swal
            .fire({
              title: 'Atenção!',
              text: 'Xml enviado com sucesso, agora ele será processando pelo esocial e você será notificando quando terminar!',
              type: 'success',
              showCancelButton: false
            })
            .then(result => {
              if (result.value) {
                this.Enviarxml("I");
              }
            });
        }
      },
      (error: any) => {
        this.Carregando = false;
      }
    );
  }

  Enviarxml(item: any): void {

    this.utilServico
      .Post(
        'TabelaRubrica/S1000Xml',
        {
          tipo_xml: 'I',
          usuario_id: this.usuario_id,
          db_config: this.db_config,
          segurado_id: 0
        },
        true
      )
      .subscribe(
        (data: any) => {
          var event = document.createEvent('CustomEvent');
          event.initCustomEvent('EnviarDadosString', true, true, {
            metodo: 'ExEsocial',
            xml: data.xml,
            ambiente: data.Ambiente,
            retaguarda: data.Retaguarda,
            ws: this.utilDadosLogado.DadosAcesso().url,
            tipoenvio: 'N'
          });
          document.documentElement.dispatchEvent(event);
          this.dialogRef.close();
          this.router.navigate(['/principal/individual']);
        },
        (error: any) => {
          swal.fire({
            title: 'Atenção!',
            type: 'warning',
            text: 'Favor preencher o formulário antes de realizar o envio.'
          });
        }
      );
  }

  showWarning(message: string) {
    Swal.fire({
      title: 'Atenção',
      text: message,
      type: 'warning',
      timer: 5000,
      showConfirmButton: false
    });
  }
}
